import gql from 'graphql-tag';

export const HIRING_ORGANIZATION_ID_FRAGMENT = gql`
  fragment hiringOrganizationIdFields on HiringOrganization {
    __typename
    id {
      value
    }
    name
    seekAnzAdvertiserId
  }
`;
